import { ModalController } from "./Controller/ModalController.js";
import { AlertModalController } from "./Controller/AlertModalController.js";
import { ConfirmModalController } from "./Controller/ConfirmModalController.js";
import { ErrorModalController } from "./Controller/ErrorModalController.js";
import { LoadingModalController } from "./Controller/LoadingModalController.js";
import { NoInternetModalController } from "./Controller/NoInternetModalController.js";
import { SuccessModalController } from "./Controller/SuccessModalController.js";
import { TermsModalController } from "./Controller/TermsModalController.js";
import { CopySuccessToastController } from "./Controller/CopySuccessToastController.js";
//redeem
import { ConfirmRedeemModalController } from "@/components/RedeemModal/Controller/ConfirmRedeemModalController.js";
import { DrawDeliveryModalController } from "@/components/RedeemModal/Controller/DrawDeliveryModalController.js";
import { SerialModalController } from "@/components/RedeemModal/Controller/SerialModalController.js";
import { RedeemSuccessModalController } from "@/components/RedeemModal/Controller/RedeemSuccessModalController.js";

export default function ModalFactory() {
    this.modalController = new ModalController();

    //#region generic
    this.alertModal = null;
    this.confirmModal = null;
    this.errorModal = null;
    this.loadingModal = null;
    this.successModal = null;
    this.termsModal = null;
    this.copySuccessToast = null;

    this.getModalController = function () {
        return this.modalController;
    };

    this.getAlertModal = function () {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };

    this.getConfirmModal = function () {
        this.confirmModal = new ConfirmModalController();
        this.modalController.setConfirmModal(this.confirmModal);
        return this.confirmModal;
    };

    this.getErrorModal = function () {
        this.errorModal = new ErrorModalController();
        this.modalController.setErrorModal(this.errorModal);
        return this.errorModal;
    };

    this.getLoadingModal = function () {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };

    this.getNoInternetModal = function () {
        this.noInternetModal = new NoInternetModalController();
        this.modalController.setNoInternetModal(this.noInternetModal);
        return this.noInternetModal;
    };

    this.getSuccessModal = function () {
        this.successModal = new SuccessModalController();
        this.modalController.setSuccessModal(this.successModal);
        return this.modalController;
    };

    this.getTermsModal = function () {
        this.termsModal = new TermsModalController();

        if (this.alertModal) {
            this.termsModal.setAlertModal(this.alertModal);
        }
        if (this.noInternetModal) {
            this.termsModal.setNoInternetModal(this.noInternetModal);
        }

        this.modalController.setTermsModal(this.termsModal);
        return this.termsModal;
    };

    this.getCopySuccessToast = function () {
        this.copySuccessToast = new CopySuccessToastController();
        this.modalController.setCopySuccessToast(this.copySuccessToast);
        return this.copySuccessToast;
    };
    //#endregion generic

    //#region redeem
    this.confirmRedeemModal = null;
    this.drawDeliveryModal = null;
    this.redeemSuccessModal = null;
    this.serialModal = null;

    this.getConfirmRedeemModal = function () {
        this.confirmRedeemModal = new ConfirmRedeemModalController();
        this.modalController.setConfirmRedeemModal(this.confirmRedeemModal);
        return this.confirmRedeemModal;
    };

    this.getDrawDeliveryModal = function () {
        this.drawDeliveryModal = new DrawDeliveryModalController();
        this.modalController.setDrawDeliveryModal(this.drawDeliveryModal);
        return this.drawDeliveryModal;
    };

    this.getRedeemSuccessModal = function () {
        this.redeemSuccessModal = new RedeemSuccessModalController();

        if (this.loadingModal) {
            this.redeemSuccessModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setRedeemSuccessModal(this.redeemSuccessModal);
        return this.redeemSuccessModal;
    };

    this.getSerialModal = function () {
        this.serialModal = new SerialModalController();

        if (this.alertModal) {
            this.serialModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.serialModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.serialModal.setLoadingModal(this.loadingModal);
        }
        if (this.redeemSuccessModal) {
            this.serialModal.setRedeemSuccessModal(this.redeemSuccessModal);
        }
        if (this.successModal) {
            this.serialModal.setSuccessModal(this.successModal);
        }
        if (this.errorModal) {
            this.serialModal.setErrorModal(this.errorModal);
        }
        if (this.copySuccessToast) {
            this.serialModal.setCopySuccessToast(this.copySuccessToast);
        } else {
            this.copySuccessToast = this.getCopySuccessToast();
            this.serialModal.setCopySuccessToast(this.copySuccessToast);
        }

        this.modalController.setSerialModal(this.serialModal);
        return this.serialModal;
    };
    //#endregion redeem
}
